import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'downArrowSVG',
  opacity = props.opacity,
}) => (
  <svg
    viewBox="0 0 155.7 140.1"
    height={height}
    width={width}
    opacity={opacity}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon points="39.5,57.7 116.2,57.7 78,117.1 " />
  </svg>
);

export default SVG;
